import React from 'react';

/**
 * 텍스트 내에서 검색어(highlight)와 일치하는 부분을 강조해 주는 컴포넌트.
 * 정규표현식을 사용하여 대소문자 구분 없이 매칭되는 텍스트를 스타일링된 span으로 감쌉니다.
 */
/**
 * 정규표현식 특수 문자를 이스케이프 처리하는 헬퍼 함수.
 * 사용자가 [, *, ? 등을 검색해도 에러가 나지 않도록 합니다.
 */
const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $&는 일치한 전체 문자열을 의미
};

const HighlightedText = ({ text = '', highlight = '', className = '' }) => {
    // 강조할 텍스트가 없거나 검색어가 없는 경우 원본 반환
    if (!highlight || !highlight.trim()) {
        return <span className={className}>{text}</span>;
    }

    try {
        // 검색어 내의 특수문자를 안전하게 이스케이프 처리
        const safeHighlight = escapeRegExp(highlight.trim());
        const parts = text.split(new RegExp(`(${safeHighlight})`, 'gi'));

        return (
            <span className={className}>
                {parts.map((part, i) =>
                    part.toLowerCase() === highlight.toLowerCase() ? (
                        <span
                            key={i}
                            className="text-blue-600 font-extrabold bg-blue-50/80 rounded-[2px]"
                        >
                            {part}
                        </span>
                    ) : (
                        part
                    )
                )}
            </span>
        );
    } catch (e) {
        // 정규표현식 오류 발생 시 (예: 잘못된 특수문자 입력 등) 원본 반환
        console.error('Highlight error:', e);
        return <span className={className}>{text}</span>;
    }
};

export default HighlightedText;
